<template>
    <div>
        <div :class="['left', {'open': openMenu}]">
            <div class="wrapper-mobile" @click="openMenu = !openMenu"></div>
            <div class="menu">
                <ul>
                    <template v-for="item in menu">
                    <li v-if="(item.permission && $store.getters.checkPermission(item.permission))
                                || !item.permission">
                        <template v-if="item.link !== 'site'">
                            <router-link :to="{ name: item.link }">
                                <span :class="['icon', 'ico-mi', 'icon-'+item.icon]"></span>
                                <span class="label">{{ item.title }}</span>
                            </router-link>
                        </template>
                        <template v-else>
                            <a href="/" target="_blank">
                                <span :class="['icon', 'ico-mi', 'icon-'+item.icon]"></span>
                                <span class="label">{{ item.title }}</span>
                            </a>
                        </template>

                        <div class="submenu" v-if="item.children.length > 0">
                            <p class="submenu__label">{{ item.submenuTitle }}</p>
                            <ul>
                                <li v-if="(itemSubmenu.permission &&
                                            $store.getters.checkPermission(itemSubmenu.permission))
                                            || !itemSubmenu.permission"
                                    v-for="itemSubmenu in item.children"
                                    @click="openMenu = !openMenu">
                                    <router-link :to="{ name: itemSubmenu.link }">
                                        {{ itemSubmenu.title }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    </template>

                    <li class="mobile-button">
                        <router-link :to="{ name: null }">
                            <span :class="['icon', 'ico-mi', 'icon-settings']"></span>
                            <span class="label">My settings</span>
                        </router-link>
                        <div class="submenu">
                            <p class="submenu__label">
                                {{ $store.state.user.first_name }} {{ $store.state.user.last_name }}
                            </p>
                            <ul>
                                <li v-for="lang in $ml.list" :key="lang">
                                    <a href="#" @click="setLang(lang)">
                                        {{ lang }}
                                    </a>
                                </li>
                                <li>
                                    <a href="#" @click="exitUser">
                                        {{ $ml.get('dashboard.exit') }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right">
            <div class="top">
                <div class="title">
                    {{ $store.state.dashboardTitle }}
                </div>

                <div class="user">
                    <div class="profile">
                        {{ $store.state.user.first_name }} {{ $store.state.user.last_name }}
                    </div>
                    <div class="language">
                        <ul>
                            <li :class="{'active' : lang === $ml.current}"
                                v-for="lang in $ml.list" :key="lang" v-text="lang" @click="setLang(lang)">
                            </li>
                        </ul>
                    </div>
                    <span class="exit" @click="exitUser">
                        {{ $ml.get('dashboard.exit') }}
                    </span>
                </div>

                <div class="mobile-menu">
                    <span class="icon ico-mi icon-menu" @click="openMenu = !openMenu"></span>
                </div>
            </div>

            <div class="content">
                <router-view></router-view>
            </div>
        </div>


        <Notifications></Notifications>
        <ErrorModalWindow></ErrorModalWindow>
        <SuccessModalWindow></SuccessModalWindow>
        <LoadingModal></LoadingModal>

    </div>
</template>

<script>
import SuccessModalWindow from "./Utils/SuccessModalWindow";
import ErrorModalWindow from "./Utils/ErrorModalWindow";
import LoadingModal from "./Utils/LoadingModal";
import Notifications from "./Utils/Notifications";

export default {
    name: "Layout",
    components: {
        LoadingModal,
        ErrorModalWindow,
        SuccessModalWindow,
        Notifications,
    },

    data() {
        return {
            userPermission: null,
            permissions: {
                1: 'user',
                3: 'admin',
            },

            openMenu: false,
            menu: [
                {
                    title: 'Artifcts',
                    icon: 'home',
                    link: 'site',
                    children: []
                },
                {
                    title: this.$ml.get('menu.artifacts.title'),
                    icon: 'artifact',
                    link: null,
                    permission: 'artifact',
                    submenuTitle: this.$ml.get('menu.artifacts.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.artifacts.artifact'), link: 'artifact', permission: 'artifact.items', },
                        { title: this.$ml.get('menu.artifacts.type'), link: 'type', permission: 'artifact.type' },
                        { title: this.$ml.get('menu.artifacts.tag'), link: 'tag', permission: 'artifact.tag' },
                        { title: this.$ml.get('menu.artifacts.document'), link: 'document', permission: 'artifact.document' },
                        { title: this.$ml.get('menu.artifacts.occasion'), link: 'occasion', permission: 'artifact.occasion' },
                        { title: this.$ml.get('menu.artifacts.country'), link: 'country', permission: 'artifact.country' },
                        { title: this.$ml.get('menu.artifacts.century'), link: 'century', permission: 'artifact.century' },
                        { title: this.$ml.get('menu.artifacts.value'), link: 'value', permission: 'artifact.value' },
                        { title: this.$ml.get('menu.artifacts.unit'), link: 'unit', permission: 'artifact.unit' },
                        { title: this.$ml.get('menu.artifacts.valuation'), link: 'valuation', permission: 'artifact.valuation' },
                        { title: this.$ml.get('menu.artifacts.violation_reports'), link: 'violation-reports', permission: 'artifact.violation-report' },
                        { title: this.$ml.get('menu.artifacts.brain_health'), link: 'brain-health', permission: 'artifact.brain-health.view_list' },
                    ]
                },
                {
                    title: this.$ml.get('menu.subscriptions.title'),
                    icon: 'subscription',
                    link: null,
                    permission: 'subscription',
                    submenuTitle: this.$ml.get('menu.subscriptions.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.subscriptions.subscription'), link: 'subscription' },
                        { title: this.$ml.get('menu.subscriptions.subscription_gift'), link: 'subscription_gift' },
                        { title: this.$ml.get('menu.subscriptions.transaction'), link: 'transaction' },
                        { title: this.$ml.get('menu.subscriptions.plan'), link: 'plan' },
                        { title: this.$ml.get('menu.subscriptions.plan_description'), link: 'plan_description' },
                        { title: this.$ml.get('menu.subscriptions.plan_permission'), link: 'plan_permission' },
                        { title: this.$ml.get('menu.subscriptions.concierge_service'), link: 'concierge_service' },
                        { title: this.$ml.get('menu.subscriptions.artiProMembership'), link: 'artiProMembership' },
                    ]
                },
                {
                    title: this.$ml.get('menu.companies.title'),
                    icon: 'companies',
                    link: null,
                    permission: 'company',
                    submenuTitle: this.$ml.get('menu.companies.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.companies.companies'), link: 'company' },
                        { title: this.$ml.get('menu.companies.request'), link: 'company.request' },
                        { title: this.$ml.get('menu.companies.forProfessionals'), link: 'forProfessionals' },
                    ]
                },
                {
                    title: this.$ml.get('menu.marketing.title'),
                    icon: 'marketing',
                    link: null,
                    permission: 'marketing',
                    submenuTitle: this.$ml.get('menu.marketing.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.marketing.promo_code'), link: 'promo_code' },
                        { title: this.$ml.get('menu.marketing.partner_promo_code'), link: 'partner_promo_code' },
                        { title: this.$ml.get('menu.marketing.qr_code'), link: 'qr_code' },
                    ]
                },
                {
                    title: this.$ml.get('menu.blog.title'),
                    icon: 'blog',
                    link: null,
                    permission: 'blog',
                    submenuTitle: this.$ml.get('menu.blog.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.blog.category'), link: 'blog_category', permission: 'blog.category' },
                        { title: this.$ml.get('menu.blog.post'), link: 'blog_post', permission: 'blog.post' },
                    ]
                },
                {
                    title: this.$ml.get('menu.users.title'),
                    icon: 'user',
                    link: 'user',
                    permission: 'user',
                    submenuTitle: this.$ml.get('menu.users.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.users.user'), link: 'user' },
                        { title: this.$ml.get('menu.users.sharing_list'), link: 'sharing_list' },
                        { title: this.$ml.get('menu.users.circle_list'), link: 'circle_list' },
                        { title: this.$ml.get('menu.users.email_subscriptions_list'), link: 'email_subscriptions_list' },
                        { title: this.$ml.get('menu.users.how_know'), link: 'how_know' },
                    ]
                },
                {
                    title: this.$ml.get('menu.administrators.title'),
                    icon: 'administrator',
                    link: 'administrator',
                    permission: true,
                    submenuTitle: this.$ml.get('menu.administrators.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.administrators.administrator'), link: 'administrator', permission: true, },
                        { title: this.$ml.get('menu.administrators.roles'), link: 'administrator.role', permission: true, },
                        { title: this.$ml.get('menu.administrators.permissions'), link: 'administrator.permission', permission: true, },
                    ]
                },
                {
                    title: this.$ml.get('menu.content.title'),
                    icon: 'content',
                    link: 'content',
                    permission: 'content',
                    submenuTitle: this.$ml.get('menu.content.subtitle'),
                    children: [
                        //{ title: this.$ml.get('menu.content.content'), link: 'content' },
                    ]
                },
                {
                    title: this.$ml.get('menu.pages.title'),
                    icon: 'homepage',
                    link: 'homepage',
                    permission: 'homepage',
                    submenuTitle: this.$ml.get('menu.pages.subtitle'),
                    children: [
                        { title: this.$ml.get('menu.homepage.title'), link: 'homepage' },
                        { title: this.$ml.get('menu.faq.title'), link: 'faq' },
                        { title: this.$ml.get('menu.forMom.title'), link: 'forMom' },
                        { title: this.$ml.get('menu.artiPro.title'), link: 'artiPro' },
                        { title: this.$ml.get('menu.komen.title'), link: 'komen' },
                    ]
                },
            ]
        }
    },
    created() {
        this.getUser()
    },
    mounted() {},
    methods: {
        setLang(lang) {
            this.$ml.change(lang)
            location.reload()
        },


        getUser() {
            axios.get(this.$store.getters.getApiUrl('dashboard'))
            .then(({data}) => {
                if (data.success) {
                    this.$store.commit('setUser', data.user)
                    this.$store.commit('setPermissions', data.permissions)
                    this.$store.commit('setRoles', data.roles)
                }
            })
        },
        exitUser(){
            this.$store.dispatch('AUTH_LOGOUT')
            this.$router.push({name:'auth.login'})
        }
    }
}
</script>

<style scoped>

</style>
